module.exports = __webpack_public_path__ + "static/media/uk_flag.90d74a2c.svg";